// Jarvan IV — Cataclysm: slams the ground, knocking up the front 3 enemies
// for physical damage and a stun.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

const STUN_DURATION = 1;

export const jarvanCataclysm: Ability = {
  id: "jarvanCataclysm",
  displayName: "Cataclysm",
  description: "Slams the ground, knocking up and dealing physical damage to the front 3 enemies.",
  iconId: "JarvanIVCataclysm",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 3)
      .map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const targets = combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 3);
    const stats = effectiveStats(caster);
    const dmg = physicalDamage(stats.ad * 1.8 + 80);
    return targets.map(e => ({
      target: e, amount: dmg, type: "physical" as const,
      effect: { kind: "stun" as const, duration: STUN_DURATION },
    }));
  },
};
